import { createEnumMap } from 'Commons/helpers/utils/Formatter';

const cardType = ['reserved', 'estimate', 'expired'];
const cardLabel = ['Reservation', 'Estimate', 'Expired Estimate'];

const CARD_TYPE = createEnumMap(cardType);
const CARD_LABEL = createEnumMap(cardLabel);

export { CARD_LABEL, CARD_TYPE };
